import React from 'react'
import { useTranslation } from 'react-i18next'
import { useProjectLanguages } from '@renderer/hooks'

interface LanguageSelectorProps {
  className?: string
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ className = '' }) => {
  const { i18n } = useTranslation()
  // Which languages the loaded project offers (ID/EN for IDR projects,
  // ES/EN for Spanish-speaking markets, English-only elsewhere). A
  // single-language project gets no toggle — it would be irrelevant
  // noise. Operator chrome outside any project (login, register,
  // dashboard navbar before a project is loaded) still gets the picker
  // because `config?.resolvedCurrency` is undefined and that reads as
  // IDR context.
  const languages = useProjectLanguages()
  if (languages.length < 2) return null

  // English first, matching how this picker has always rendered.
  const options = ['en', ...languages.filter((lng) => lng !== 'en')]

  const changeLanguage = (lng: string): void => {
    i18n.changeLanguage(lng)
    localStorage.setItem('language', lng)
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {options.map((lng) => (
        <button
          key={lng}
          className={`px-2 py-1 rounded text-sm font-medium ${
            i18n.language === lng ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'
          }`}
          onClick={() => changeLanguage(lng)}
        >
          {lng.toUpperCase()}
        </button>
      ))}
    </div>
  )
}

export default LanguageSelector
